<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.order_date | display_date_tz }}</td>
                            <td>{{ item.meimei_code }}</td>
                            <td>{{ item.china_order_code }}</td>
                            <td>{{ item.customer_name }}</td>
                            <td>{{ item.product_code }}</td>
                            <td>{{ item.product_name }}</td>
                            <td class="text-end">{{ item.qty | currency }}</td>
                            <td class="text-end">{{ item.qty_bought | currency }}</td>
                            <td class="text-end">{{ item.qty_instore | currency }}</td>
                            <td class="text-end" v-bind:class="{'text-red': item.qty_wrong > 0}">{{ item.qty_wrong | currency }}</td>
                            <!-- <td class="text-end">
                                <v-edit-dialog :return-value.sync="item.qty_wrong" eager lazy @save="updateItem({id: item.id, qty_wrong: item.qty_wrong})">
                                    <div v-bind:class="{'text-red': item.qty_wrong > 0}">{{ item.qty_wrong | currency }}</div>
                                    <template v-slot:input>
                                        <v-text-field v-model="item.qty_wrong" type="number" step="1" label="SL sai" single-line autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td> -->
                            <td class="text-end" v-if="adminRole">
                                <v-edit-dialog :return-value.sync="item.exchange_rate" eager lazy @save="updateItem({id: item.id, exchange_rate: item.exchange_rate})">
                                    <div>{{ item.exchange_rate | currency }}</div>
                                    <template v-slot:input>
                                        <v-text-field v-model="item.exchange_rate" type="number" step="1" label="Tỷ giá" single-line autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-end" v-if="adminRole">
                                <v-edit-dialog :return-value.sync="item.amount_cny" eager lazy @save="updateItem({id: item.id, amount_cny: item.amount_cny})">
                                    <div>{{ item.amount_cny | currency('',1) }}</div>
                                    <template v-slot:input>
                                        <v-text-field v-model="item.amount_cny" type="number" step=".1" label="Tiền hàng (¥)" single-line autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-end" v-if="adminRole">{{ item.amount_vnd | currency }}</td>
                            <td class="text-end">
                                <v-edit-dialog :return-value.sync="item.weight" eager lazy @save="updateItem({id: item.id, weight: item.weight})">
                                    <div>{{ item.weight | currency('',1) }}</div>
                                    <template v-slot:input>
                                        <v-text-field v-model="item.weight" type="number" step=".1" label="Cân nặng" single-line autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-end" v-if="adminRole">{{ item.weight_amount | currency }}</td>
                            <td class="text-end" v-if="adminRole">{{ item.total_amount | currency }}</td>
                            <td class="text-end" v-if="adminRole">{{ item.product_price_avg | currency }}</td>
                        </tr>
                    </template>
                    <template v-slot:body.append v-if="summary">
                      <tr class="total-summary-td">
                          <td colspan="6" class="text-end font-weight-bold">Tổng:</td>
                          <td class="text-end font-weight-bold">{{ summary.qty | currency}}</td>
                          <td class="text-end font-weight-bold">{{ summary.qty_bought | currency}}</td>
                          <td class="text-end font-weight-bold">{{ summary.qty_instore | currency}}</td>
                          <td class="text-end font-weight-bold">{{ summary.qty_wrong | currency}}</td>
                          <td class="text-end font-weight-bold" v-if="adminRole"></td>
                          <td class="text-end font-weight-bold" v-if="adminRole">{{ summary.amount_cny | currency('',1)}}</td>
                          <td class="text-end font-weight-bold" v-if="adminRole">{{ summary.amount_vnd | currency}}</td>
                          <td class="text-end font-weight-bold">{{ summary.weight | currency('',1)}}</td>
                          <td class="text-end font-weight-bold" v-if="adminRole">{{ summary.weight_amount | currency}}</td>
                          <td class="text-end font-weight-bold" v-if="adminRole">{{ summary.total_amount | currency}}</td>
                          <td class="text-end font-weight-bold" v-if="adminRole"></td>
                      </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            viewName: "china_orders",
            dialogItem: false,
            
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.china_orders.all.data,
            total_rows: state => state.china_orders.all.total,
            summary: state => state.china_orders.all.summary,
            loading: state => state.china_orders.loading,
            currentItem: (state) => state.china_orders.selected
        }),
        adminRole() {
            return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Admin;
        },
        staffRole() {
            return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Staff;
        },
        headers() {
            let tmp = [
                {
                    text: "Ngày",
                    value: "order_date",
                    filterable: true,
                    width: "100px",
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Đơn hàng",
                    value: "meimei_code",
                    filterable: true,
                    quickSearch: true,
                    width: "110px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Đơn TQ",
                    value: "china_order_code",
                    filterable: true,
                    quickSearch: true,
                    width: "150px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Tên khách",
                    value: "customer_name",
                    filterable: true,
                    quickSearch: true,
                    width: "150px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã SP",
                    value: "product_code",
                    filterable: true,
                    quickSearch: true,
                    width: "110px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Tên SP",
                    value: "product_name",
                    filterable: true,
                    quickSearch: true,
                    width: "150px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "SL.đặt",
                    value: "qty",
                    filterable: true,
                    align: "end",
                    width: "60px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "SL.mua",
                    value: "qty_bought",
                    filterable: true,
                    align: "end",
                    width: "60px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "SL.về",
                    value: "qty_instore",
                    filterable: true,
                    align: "end",
                    width: "60px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "SL.sai",
                    value: "qty_wrong",
                    filterable: true,
                    align: "end",
                    width: "60px",
                    dataType: configs.DATA_TYPE["Number"]
                }
            ];
            if(this.adminRole) {
                tmp = tmp.concat([
                    {
                        text: "Tỷ giá",
                        value: "exchange_rate",
                        filterable: true,
                        align: "end",
                        width: "80px",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tiền hàng (¥)",
                        value: "amount_cny",
                        filterable: true,
                        align: "end",
                        width: "130px",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tiền hàng (đ)",
                        value: "amount_vnd",
                        filterable: true,
                        align: "end",
                        width: "130px",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Cân nặng",
                        value: "weight",
                        filterable: true,
                        align: "end",
                        width: "110px",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tiền cân",
                        value: "weight_amount",
                        filterable: true,
                        align: "end",
                        width: "110px",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Thành tiền",
                        value: "total_amount",
                        filterable: true,
                        align: "end",
                        width: "130px",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Giá SP",
                        value: "product_price_avg",
                        filterable: true,
                        align: "end",
                        width: "120px",
                        dataType: configs.DATA_TYPE["Number"]
                    }
                ]);
            }
            else {
                tmp = tmp.concat([
                    {
                        text: "Cân nặng",
                        value: "weight",
                        filterable: true,
                        align: "end",
                        width: "110px",
                        dataType: configs.DATA_TYPE["Number"]
                    }
                ]);
            }
            return tmp;
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("china_orders/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        updateItem(item) {
            this.$store.dispatch("china_orders/setDetail", {id: item.id, data: item}); 
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
